import React from 'react';
import {
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import { createStyles, makeStyles } from '@material-ui/core/styles';

export type ProcessingDialogState = 'close' | 'wait' | 'error';
export interface ProcessingDialogProps {
  state: ProcessingDialogState;
  onClickError?: React.MouseEventHandler<HTMLButtonElement>;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
    errorTitle: {
      '& h2': {
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
        lineHeight: '32px',
      },
      '& svg': {
        color: '#e91e63',
        marginRight: '10px',
      },
    },
    okButton: {
      color: '#e91e63',
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: 'normal',
      transition: 'none !important',
      borderRadius: '2px',
      '&:hover': {
        backgroundColor: '#fce8ef',
      },
    },
  }),
);

export const ProcessingDialog: React.FC<ProcessingDialogProps> = ({
  state,
  onClickError = () => {},
}) => {
  const classes = useStyles();

  return (
    <>
      <Backdrop open={state === 'wait'} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog open={state === 'error'}>
        <DialogTitle className={classes.errorTitle}>
          <WarningIcon />
          サーバとの通信中に問題が発生しました。
        </DialogTitle>
        <DialogContent>
          しばらく時間をおいて、再送信してください。
        </DialogContent>
        <DialogActions>
          <Button onClick={onClickError} className={classes.okButton}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
